<template>
  <div v-if="tournament && tournament.location">
    <md-toolbar v-if="isMine(tournament)">
      <md-button @click="save()" class="md-icon-button" :disabled="disableSave">
        <md-icon>save</md-icon>
        <md-tooltip>Save venue usage</md-tooltip>
      </md-button>
    </md-toolbar>
    <md-list>
      <md-list-item v-for="venue in tournament.location.venues" :key="venue.id">
        <md-switch
          v-model="inUse"
          :value="venue.id"
        >{{venue.name}}{{venue.reservedBy && ` - ${venue.reservedBy}`}}</md-switch>
      </md-list-item>
    </md-list>
  </div>
  <div v-else>
    <p>Location is not set for this tournament</p>
  </div>
</template>

<script>
import gql from "graphql-tag";
import { TournamentTools } from "@/js/helper";
import { tournamentVenueFragment } from "@/graphql/tournament";

export default {
  name: "TournamentVenues",
  props: { tournament: Object },
  data: function() {
    return {
      inUse: []
    };
  },
  computed: {
    disableSave: {
      get() {
        // disable saving unless the selections have changed
        if (this.tournament && this.tournament.venuesToUse) {
          if (this.inUse.length === this.tournament.venuesToUse.length)
            return (
              this.tournament.venuesToUse.filter(
                x => !this.inUse.includes(x.id)
              ).length == 0
            );
          return false;
        }
        return true;
      }
    }
  },
  methods: {
    isMine: TournamentTools.isMine,
    copyVenues() {
      if (this.tournament && this.tournament.venuesToUse)
        this.inUse = this.tournament.venuesToUse.map(x => x.id);
      else this.inUse = [];
    },
    save() {
      return this.$apollo
        .mutate({
          mutation: gql`
            mutation($tournamentId: ID!, $venueIds: [ID!]!) {
              setVenuesToUse(tournamentId: $tournamentId, venueIds: $venueIds) {
                id
                venuesToUse {
                  ...TournamentVenue
                }
              }
            }
            ${tournamentVenueFragment}
          `,
          variables: {
            tournamentId: this.tournament.id,
            venueIds: this.inUse
          }
        })
        .then(result => {
          //this.$root.$emit("updateTournament", this.tournament.id);
          this.$store.commit("setNotification", `Venue configuration updated`);
        })
        .catch(err => {
          console.log(err);
          window.alert("Failed to update venue configurations");
        });
    }
  },
  watch: {
    tournament: {
      handler(val) {
        this.copyVenues();
      },
      deep: true
    }
  },
  created() {
    this.copyVenues();
  }
};
</script>


// WEBPACK FOOTER //
// tournamentVenues.vue?2f9f0e5d